import { render, staticRenderFns } from "./UsersSetup.vue?vue&type=template&id=fcfef94a&"
import script from "./UsersSetup.vue?vue&type=script&lang=js&"
export * from "./UsersSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports